import { Routes } from '@angular/router';
import { CustomerAreaComponent } from './customer-area.component';
import { privateOnlyCanMatch } from '../../../guards/auth-private.guard';

export const customerAreaRoutes: Routes = [
  {
    path: 'customer',
    component: CustomerAreaComponent,
    canMatch: [privateOnlyCanMatch],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadComponent: () =>
          import(
            '../../pages/customer/pages/dashboard/dashboard.component'
          ).then((x) => x.DashboardComponent),
      },
      {
        path: 'orders',
        loadComponent: () =>
          import(
            '../../pages/customer/pages/order/order-list/order-list.component'
          ).then((x) => x.OrderListComponent),
      },
      {
        path: 'orders/details/:id',
        loadComponent: () =>
          import(
            '../../pages/customer/pages/order/order-details/order-details.component'
          ).then((x) => x.OrderDetailsComponent),
      },
      {
        path: 'cards',
        loadComponent: () =>
          import(
            '../../pages/customer/pages/credit-card/credit-card.component'
          ).then((x) => x.CreditCardComponent),
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('../../pages/customer/pages/profile/profile.component').then(
            (x) => x.ProfileComponent
          ),
      },
    ],
  },
];
